export default "__VITE_ASSET__BZnnJ_6f__"